import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import ApexCharts from 'apexcharts';
import { ToastrService } from 'ngx-toastr';
import { ResponseObject } from 'src/app/models/response-object.model';
import { ChartService } from 'src/app/services/chart.service';

@Component({
  selector: 'app-accounting-chart-profits-vs-costs',
  templateUrl: './accounting-chart-profits-vs-costs.component.html',
  styleUrls: ['./accounting-chart-profits-vs-costs.component.scss']
})
export class AccountingChartProfitsVsCostsComponent implements OnInit {
  year = null;
  years = [];
  constructor(
    private chartService: ChartService,
    private toastService: ToastrService
  ) {
    this.year = new Date().getFullYear();
    var origin = 2022;
    for (let index = origin; index <= (this.year + 3); index++) {
      this.years.push(index);
    }
  }

  ngOnInit(): void {
    this.updateChart();
  }

  updateChart() {
    document.querySelector("#accounting-chart-profits-vs-costs").innerHTML = "";
    this.chartService.getProfitVsCosts(this.year).subscribe({
      next: (response: ResponseObject) => {
        var incomeData = response.data;
        var profit = incomeData.profit >= 0 ? incomeData.profit : 0;
        var lost = incomeData.profit < 0 ? incomeData.profit * -1 : 0;

        var totalExpensesAndCosts = incomeData.salesCosts + incomeData.expenses + profit;

        var totalIncomesAndLost = incomeData.income + lost;

        var percentages = {
          //grafica de arriba
          costs: (incomeData.salesCosts / totalExpensesAndCosts * 100).toFixed(2),
          expenses: (incomeData.expenses / totalExpensesAndCosts * 100).toFixed(2),
          profit: (profit / totalExpensesAndCosts * 100).toFixed(2),
          //grafica de abajo
          lost: (lost / totalIncomesAndLost * 100).toFixed(2),
          income: (incomeData.income / totalIncomesAndLost * 100).toFixed(2)
        };
        console.log('porcentajes', percentages);

        const options = {
          chart: {
            height: 350,
            type: 'bar',
            stacked: true,
            stackType: '100%'
          },
          colors: ['#fdfd96', '#ff964f', '#77dd77', '#b4d9ef', '#ff6961'],
          plotOptions: {
            bar: {
              horizontal: true
            },
          },
          stroke: {
            width: 1,
            colors: ['transparent']
          },
          series: [{
            name: 'Costos',
            data: [percentages.costs, 0]
          }, {
            name: 'Gastos',
            data: [percentages.expenses, 0]
          }, {
            name: 'Ganancias',
            data: [percentages.profit, 0]
          }, {
            name: 'Ingresos',
            data: [0, percentages.income]
          }, {
            name: 'Perdidas',
            data: [0, percentages.lost]
          }],
          xaxis: {
            categories: ['Costos + Gastos + Ganancias', 'Ingresos y Pérdidas'],
          },
          tooltip: {
            y: {
              formatter: function (val: any) {
                return val + "%"
              }
            }
          },
          fill: {
            opacity: 1
          },
          legend: {
            position: 'top',
            horizontalAlign: 'left',
          }
        }
        const chart = new ApexCharts(
          document.querySelector("#accounting-chart-profits-vs-costs"),
          options
        );
        chart.render();
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
      }
    });
  }
}
